<template>
  <keep-alive>
    <component v-bind:is="commsComponent"></component>
  </keep-alive>
</template>

<script>
import CommsPageDesktop from "./CommsPageDesktop";
import CommsPageMobile from "./CommsPageMobile";

export default {
  name: "CommsPage",
  metaInfo: {
    title: "Comms"
  },
  components: {
    CommsPageDesktop,
    CommsPageMobile,
  },
  computed: {
    commsComponent() {
      if(this.$store.state.isMobile) {
        return 'CommsPageMobile';
      }

      return 'CommsPageDesktop';
    }
  }
}
</script>
